import { render, staticRenderFns } from "./AddKpiBasic.vue?vue&type=template&id=78f83a9d"
import script from "./AddKpiBasic.vue?vue&type=script&lang=js"
export * from "./AddKpiBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports